import { createFeatureSelector, createSelector } from "@ngrx/store";
import { EventState } from "./event.reducer";

export const selectEventState = createFeatureSelector<EventState>('events');

export const selectEventList = createSelector(
    selectEventState,
    (state: EventState) => state.events
)

export const selectEventLoading = createSelector(
    selectEventState,
    (state: EventState) => state.loading
)

export const selectEventSelected = createSelector(
    selectEventState,
    (state) => {
        return state.selectedEventDetail
    }
)

export const selectEventIdSelected = createSelector(
    selectEventState,
    (state) => {
        return state.selectedEventId
    }
)

export const selectEventBySlug = (slug: string) =>
    createSelector(
        selectEventState,
        (state) => {
            console.log(state.events.find((e) => e.link === slug), slug);
            return state.events.find((e) => e.link === slug) ?? null
        }
    );